/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Account/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import CheckedIn from './CheckedIn/index'
import DayOfBirth from './DayOfBirth/index'
import GoToFrontDesk from './GoToFrontDesk/index'
import LastNameFirstLetter from './LastNameFirstLetter/index'
import MonthOfBirth from './MonthOfBirth/index'
import React from 'react'
import Sending from './Sending/index'
import Start from './Start/index'



/** @type {import('Simple/types.js').View} */
export default function Account({
  children,
  viewPath = "/App/Account"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Start'
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'Start'}>
<Start
  viewPath={`${viewPath}/Start`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'LastNameFirstLetter'}>
<LastNameFirstLetter
  viewPath={`${viewPath}/LastNameFirstLetter`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'DayOfBirth'}>
<DayOfBirth
  viewPath={`${viewPath}/DayOfBirth`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'MonthOfBirth'}>
<MonthOfBirth
  viewPath={`${viewPath}/MonthOfBirth`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Sending'}>
<Sending
  viewPath={`${viewPath}/Sending`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'CheckedIn'}>
<CheckedIn
  viewPath={`${viewPath}/CheckedIn`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'GoToFrontDesk'}>
<GoToFrontDesk
  viewPath={`${viewPath}/GoToFrontDesk`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}